import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { useT } from '../i18n/translations';
import { PRODUCTS } from '../data/catalog';
import Drawer from './Drawer';
import Icon from './Icon';
import './CartDrawer.css';

export default function CartDrawer() {
  const {
    cart,
    dispatch,
    fx,
    cartSubtotal,
    cartTotal,
    couponDiscount,
    vipRebate,
    vipTier,
    appliedCoupon,
    applyCoupon,
    cartCount,
    closeDrawer,
    navigate,
    lang,
    user,
    openDrawer,
  } = useApp();
  const t = useT(lang);
  const [coupon, setCoupon] = useState('');

  const onApply = () => {
    if (coupon.trim()) {
      applyCoupon(coupon);
      setCoupon('');
    }
  };

  const onCheckout = () => {
    if (!user) {
      openDrawer('auth');
      return;
    }
    closeDrawer();
    navigate('checkout');
  };

  return (
    <Drawer
      id="cart"
      title={`${t.cart.title} · ${cartCount} ${t.cart.itemCount}`}
      icon="cart"
      width={460}
      footer={
        cart.length === 0 ? null : (
          <>
            <div className="nx-cart__summary">
              <div className="nx-cart__row">
                <span>{t.cart.subtotal}</span>
                <span>{fx(cartSubtotal)}</span>
              </div>
              {couponDiscount > 0 && (
                <div className="nx-cart__row nx-cart__row--save">
                  <span><Icon name="discount" size={12} /> {t.cart.discount}</span>
                  <span>-{fx(couponDiscount)}</span>
                </div>
              )}
              {user && vipRebate > 0 && (
                <div className="nx-cart__row nx-cart__row--vip">
                  <span><Icon name="crown" size={12} /> {t.cart.vipRebate} ({vipTier.name} {vipTier.rebate})</span>
                  <span>+{fx(vipRebate)} 點</span>
                </div>
              )}
              <div className="nx-cart__row nx-cart__row--total">
                <span>{t.cart.total}</span>
                <strong>{fx(cartTotal)}</strong>
              </div>
            </div>
            <button className="btn btn-primary btn-block btn-lg" onClick={onCheckout}>
              {t.cta.checkout} <Icon name="arrowRight" size={16} />
            </button>
          </>
        )
      }
    >
      {cart.length === 0 ? (
        <div className="nx-cart__empty">
          <div className="nx-cart__empty-icon">
            <Icon name="cart" size={40} />
          </div>
          <h4>{t.cart.empty}</h4>
          <p>{t.cart.emptyHint}</p>
          <button
            className="btn btn-primary"
            onClick={() => {
              closeDrawer();
              navigate('category', { id: 'all' });
            }}
          >
            {t.cta.continueShopping}
          </button>
        </div>
      ) : (
        <>
          <ul className="nx-cart__list">
            {cart.map((it) => {
              const prod = PRODUCTS.find((p) => p.id === it.productId);
              return (
              <li key={it.key} className="nx-cart__item">
                <div
                  className="nx-cart__art brand-tile"
                  style={{ '--brand-bg': it.color || prod?.bg || '#14161c' }}
                >
                  {prod?.logoUrl ? (
                    <img src={prod.logoUrl} alt={prod.en || it.name} loading="lazy" />
                  ) : (
                    <em>{prod?.logoText || it.name.slice(0, 2)}</em>
                  )}
                </div>
                <div className="nx-cart__info">
                  <div className="nx-cart__name">{it.name}</div>
                  <div className="nx-cart__price">{fx(it.price)}</div>
                  <div className="nx-cart__qty">
                    <button
                      onClick={() =>
                        dispatch({ type: 'UPDATE_QTY', key: it.key, qty: it.qty - 1 })
                      }
                      aria-label="-"
                    >
                      <Icon name="minus" size={12} />
                    </button>
                    <span>{it.qty}</span>
                    <button
                      onClick={() =>
                        dispatch({ type: 'UPDATE_QTY', key: it.key, qty: it.qty + 1 })
                      }
                      aria-label="+"
                    >
                      <Icon name="plus" size={12} />
                    </button>
                  </div>
                </div>
                <div className="nx-cart__line">
                  <button
                    className="nx-cart__remove"
                    onClick={() => dispatch({ type: 'REMOVE', key: it.key })}
                    aria-label="Remove"
                  >
                    <Icon name="trash" size={14} />
                  </button>
                  <div className="nx-cart__subtotal">{fx(it.price * it.qty)}</div>
                </div>
              </li>
              );
            })}
          </ul>

          <button
            className="nx-cart__clear"
            onClick={() => dispatch({ type: 'CLEAR' })}
          >
            <Icon name="trash" size={12} /> {t.cart.removeAll}
          </button>

          <div className="nx-cart__coupon">
            <Icon name="discount" size={14} />
            <input
              placeholder={t.cart.couponPlaceholder}
              value={coupon}
              onChange={(e) => setCoupon(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && onApply()}
            />
            <button className="btn btn-sm btn-primary" onClick={onApply}>
              {t.cta.apply}
            </button>
          </div>
          {appliedCoupon && (
            <div className="nx-cart__applied">
              <Icon name="check" size={12} /> 已套用 <strong>{appliedCoupon}</strong>
              <button
                onClick={() => dispatch({ type: 'REMOVE_COUPON' })}
                aria-label="Remove coupon"
              >
                <Icon name="close" size={12} />
              </button>
            </div>
          )}
          <div className="nx-cart__codes">
            可試用：
            <code>QQCARD5</code>
            <code>HOT10</code>
            <code>WELCOME</code>
          </div>
        </>
      )}
    </Drawer>
  );
}
